<div class="js-sidebar-content" *ngIf="session$ | async as session">
	<header class="logo hidden-lg-down">
		<a href="index.html">
			<img src="{{config.logoLight}}" alt="{{config.name}}" title="{{config.name}}" />
		</a>
	</header>
	<div class="sidebar-status">
		<a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown">
            <i class="fa fa-circle text-{{status}} pull-left mr-2"></i>
			<strong class="username-truncate">{{session?.Name}}</strong>
            <b class="caret"></b>
		</a>
		<ul class="dropdown-menu dropdown-menu-right">
			<li>
				<a class="dropdown-item" [routerLink]=" ['/account'] "><i class="fas fa-user"></i> &nbsp; {{ 'navbar.settings' | translate }}</a>
			</li>
			<li class="dropdown-divider"></li>
			<li>
				<a class="dropdown-item" [routerLink]=" ['/login'] " (click)="logout()"
					><i class="fas fa-sign-out-alt"></i> &nbsp; {{ 'sidebar.logout' | translate }}</a
				>
			</li>
		</ul>
		<!-- #notifications-dropdown-menu goes here when screen collapsed to xs or sm -->
		<span class="sidebar-toggle hidden-xl-up" (click)="toggleSidebar()"><i class="fa fa-times"></i></span>

        <div *ngIf="myInfo && myInfo.length > 0">
            <div *ngFor="let item of myInfo">
                <div *ngIf="item.konto === 'Stundenkonto'">
                    {{ 'sidebar.hoursAccountShort' | translate }}: {{ extractTextFromHtml(item.wert) }}
                </div>

                <div *ngIf="item.konto === 'Urlaub planbar'">
                    {{'txPersonalFiles.holiday' | translate}}: {{ extractTextFromHtml(item.wert) }}
                </div>
            </div>
        </div>
	</div>
	<!-- main notification links are placed inside of .sidebar-nav -->
	<ng-container *ngIf="PermissionsMenuItems$ | async as items">
		<div class="side-nav" #sideMenu>
			<ng-container *ngFor="let item of items">
				<mat-divider *ngIf="item.separator"></mat-divider>
				<ng-container *ngIf="!item.separator && item.visible !== false">
					<!-- Leaf item (no children) -->
					<a *ngIf="!item.items?.length"
						class="side-nav-item ui-menuitem-link"
						[ngClass]="item.styleClass"
						[routerLink]="item.routerLink"
						routerLinkActive="ui-menuitem-link-active"
						[class.ui-state-disabled]="item.disabled"
						(click)="item.command && item.command($event)">
						<i class="side-nav-icon" [ngClass]="item.icon"></i>
						<span class="side-nav-label">{{ item.label }}</span>
					</a>
					<!-- Group with children -->
					<mat-expansion-panel *ngIf="item.items?.length"
						class="mat-elevation-z0 side-nav-group"
						[ngClass]="item.styleClass"
						[expanded]="isGroupActive(item)"
						hideToggle="false">
						<mat-expansion-panel-header>
							<mat-panel-title>
								<span>{{ item.label }}</span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<a *ngFor="let child of item.items"
							class="side-nav-item side-nav-sub-item ui-menuitem-link"
							[ngClass]="child.styleClass"
							[routerLink]="child.routerLink"
							routerLinkActive="ui-menuitem-link-active"
							[class.ui-state-disabled]="child.disabled"
							(click)="child.command && child.command($event)">
							<span>{{ child.label }}</span>
						</a>
					</mat-expansion-panel>
				</ng-container>
			</ng-container>
		</div>
	</ng-container>
	<div class="flex-spacer"></div>
	<ul class="sidebar-nav sidebar-nav--bottom">
		<!--        <li style="display: none;">-->
		<!--            <div class="sidebar-nav-title">Netzwerk-Status:</div>-->
		<!--            <div class="sidebar-status onlinestatetoggle">-->
		<!--                <p-toggleButton [(ngModel)]="networkIsOnlineButton" (onChange)="handleNetworkStateChange()"-->
		<!--                                [disabled]="true" onLabel="Online" offLabel="Offline"-->
		<!--                                [style]="{'width': '100%'}"></p-toggleButton>-->
		<!--            </div>-->
		<!--        </li>-->
		<li *ngIf="openActions$ | async as openActions">
			<div *ngIf="openActions?.length > 0" class="sidebar-queue">
				<div class="sidebar-nav-title display-flex flex-justify-content-space-between flex-align-items-center">
					Warteschlange:<i
						class="fa fa-question-circle"
						aria-hidden="true"
						matTooltip="Ihre Internet-Verbindung ist schwach. Wir speichern ihre Buchungen zwischen und senden sie sobald ihre Internet-Verbindung wieder stabil ist!"
						matTooltipPosition="above"></i>
					<button mat-icon-button [matMenuTriggerFor]="menu"><fa-icon icon="chevron-down"></fa-icon></button>
				</div>
				<div class="sidebar-status">
					<small class="text-muted">Es sind aktuell <b>{{openActions.length}}</b> Buchungen in der Warteschleife</small>
				</div>
				<div class="sidebar-sidepop">
					<mat-menu class="queue-info-list" yPosition="below" xPosition="after" #menu="matMenu">
						<div *ngFor="let action of openActions" class="queue-info-item">
							<div class="queue-info-header">{{ action.body.datetime | formatTime:"DD.MM.YYYY HH:mm:ss" }}</div>
							<div class="queue-info-content">{{ mapQueueType(action.body.buchungsart) }}</div>
						</div>
					</mat-menu>
				</div>
			</div>
		</li>
		<!--
        <li *ngIf="networkIsOnlineButton$ | async as networkIsOnline">
            <a [routerLink]=" ['/login'] " (click)="logout()" *ngIf="networkIsOnline && !isMobile && !isTablet">
                <span class="icon"><i class="fa fa-sign-out"></i></span>Log Out
            </a>
        </li>
        <li *ngIf="networkIsOnlineButton$ | async as networkIsOnline">
            <a (click)="reload()" *ngIf="networkIsOnline && !isMobile && !isTablet" [routerLink]="null">
                <span class="icon"><i class="fa fa-refresh"></i></span>{{'sidebar.reload' | translate}}
            </a>
        </li>-->
		<li *ngIf="terminalService.fastLogout | async" class="flex flex-direction-column align-items-center">
			<button mat-flat-button [routerLink]="['/login']" (click)="logout()" class="w-100" color="primary">
				<i class="fas fa-sign-out-alt mr-2"></i>{{ 'sidebar.logout' | translate }}
			</button>
		</li>
		<li>
			<a href="#" (click)="displayAppInfo()">
				<span class="icon"><i class="fa fas fa-code-branch"></i></span
				><small class="text-muted">Version: {{wlVersion}} </small>
			</a>
		</li>
	</ul>
</div>

<div *ngIf="displayAppInformation" class="tx-inline-dialog-backdrop" (click)="displayAppInformation = false">
	<mat-card class="tx-inline-dialog tx-app-info" (click)="$event.stopPropagation()">
		<mat-card-title>
			TXportal Informationen
			<button mat-icon-button (click)="displayAppInformation = false">
				<mat-icon>close</mat-icon>
			</button>
		</mat-card-title>
		<mat-card-content>
			<a href="index.html">
				<img src="{{config.logoDark}}" alt="{{config.name}}" title="{{config.name}}" />
			</a>
			<table>
				<tr>
					<td>Version:</td>
					<td>{{wlVersion}}</td>
				</tr>
				<tr>
					<td>URL:</td>
					<td>{{config.host}}</td>
				</tr>

				<tr>
					<td>API:</td>
					<td>{{config.TimeIXServerUrl}}</td>
				</tr>
				<tr>
					<td>Device:</td>
					<td>{{config.device}}</td>
				</tr>
				<tr>
					<td>Browser:</td>
					<td>{{config.browser}}</td>
				</tr>
				<tr>
					<td>Browser:</td>
					<td>{{config.browserVersion}}</td>
				</tr>
				<tr>
					<td>UserAgent:</td>
					<td>{{config.userAgent}}</td>
				</tr>
				<tr>
					<td>OS:</td>
					<td>{{config.os}}</td>
				</tr>
				<tr>
					<td>OS Version:</td>
					<td>{{config.osVersion}}</td>
				</tr>
			</table>
		</mat-card-content>
	</mat-card>
</div>
